import { NavLink } from 'react-router-dom'
import { useTheme } from '../../context/ThemeProvider'
import {
  faHouse,
  faSchool,
  faCommentMedical,
  faChildren,
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import useAuth from '../../hooks/useAuth'

const navClasses =
  'w-full text-portal-dark-purple p-1 flex-col relative rounded-lg items-center justify-center '

function Nav() {
  const { can, auth } = useAuth()
  const theme = useTheme();
  return (
    <ul className="space-y-2">
      <li className="">
        <NavLink
          to="/"
          className={({ isActive }) =>
            (isActive ? ' bg-nav-item-active shadow-inner-lg  ' : '') +
            navClasses +
            ' flex flex-col items-center gap-1 hover:text-nav-dark py-6'
          }
        >
          <FontAwesomeIcon icon={faHouse} className="text-xl" />
          <div>Home</div>
        </NavLink>
      </li>
      <li className="">
        <NavLink
          to="/referrals"
          className={({ isActive }) =>
            (isActive ? ' bg-nav-item-active shadow-inner-lg  ' : '') +
            navClasses +
            ' flex flex-col items-center gap-1 hover:text-nav-dark py-6'
          }
        >
          <FontAwesomeIcon icon={faCommentMedical} className="text-xl" />
          <div>My Referrals</div>
        </NavLink>
      </li>

      {!!auth?.user?.parent_id === false && (
        <>
          <li className=" text-portal-dark-purple">
            <NavLink
              to="/my-dependants"
              className={({ isActive }) =>
                (isActive ? ' bg-nav-item-active shadow-inner-lg py-2 ' : '') +
                navClasses +
                ' flex flex-col items-center gap-1 hover:text-nav-dark py-6'
              }
            >
              <FontAwesomeIcon icon={faChildren} className="text-xl" />
              <div>Dependants</div>
            </NavLink>
          </li>

          {theme.brand !== 'bws' && (
            <li className=" text-portal-dark-purple">
              <NavLink
                to="/my-school"
                className={({ isActive }) =>
                  (isActive ? ' bg-nav-item-active shadow-inner-lg py-2 ' : '') +
                  navClasses +
                  ' flex flex-col items-center gap-1 hover:text-nav-dark py-6'
                }
              >
                <FontAwesomeIcon icon={faSchool} className="text-xl" />
                <div>My School</div>
              </NavLink>
            </li>
          )}

        </>
      )}
    </ul>
  )
}

export default Nav
